import React, { useRef, useEffect, useId } from "react";
import { Container } from "reactstrap";
import cn from "classnames";

export default function HubSpotForm({
  customClass,
  form_src,
  portal_id = "144452896",
  form_id,
  successPageUrl,
}) {

  // Stable, SSR-safe unique ID per instance. useId() stays consistent between the
  // statically exported HTML and client hydration (Math.random() did not, which
  // broke the form on the live/exported page). Strip ":" so it is a valid CSS
  // selector for hbspt.forms.create({ target }).
  const rawId = useId();
  const containerId = `hubspot-form-container-${rawId.replace(/:/g, "")}`;

  const formRenderedRef = useRef(false);

  useEffect(() => {
    if (!form_id) return;

    // `cancelled` protects against React 18 StrictMode running the effect twice
    // (and any late script "load" event firing after unmount) — without it the
    // form would be created more than once.
    let cancelled = false;

    const renderForm = () => {
      if (cancelled || formRenderedRef.current) return;
      const container = document.getElementById(containerId);
      if (!container || !window.hbspt) return;
      container.innerHTML = "";
      formRenderedRef.current = true;
      window.hbspt.forms.create({
        portalId: portal_id,
        formId: form_id,
        target: `#${containerId}`,
        onFormSubmitted: function () {
          if (successPageUrl) {
            window.location.href = `${successPageUrl}`;
          } else {
            window.scrollTo({ top: 0, behavior: "smooth" });
          }
        },
      });
    };

    let script = document.querySelector(
      'script[src*="js-eu1.hsforms.net/forms/embed/v2.js"]'
    );

    if (window.hbspt) {
      renderForm();
    } else {
      if (!script) {
        script = document.createElement("script");
        script.src = "//js-eu1.hsforms.net/forms/embed/v2.js";
        script.async = true;
        script.onerror = () => {
          console.error("Failed to load HubSpot form script.");
        };
        document.body.appendChild(script);
      }
      script.addEventListener("load", renderForm);
    }

    return () => {
      cancelled = true;
      if (script) script.removeEventListener("load", renderForm);
      const container = document.getElementById(containerId);
      if (container) container.innerHTML = "";
      formRenderedRef.current = false;
    };
  }, [form_id, portal_id, successPageUrl, containerId]);

  return (
    <>
      <section className={cn(customClass, "mt-5")}>
        <Container>
          <div className="hbspt-form" id={containerId}></div>
        </Container>
      </section>
    </>
  );
}
